import {Inject, Injectable} from '@angular/core';
import {CoreService} from '../core/core.service';
import { HttpClient } from '@angular/common/http';
import {HTTP_CLIENT_WITH_ERROR_HANDLING} from '../app.di';
import {Observable} from 'rxjs';
import {OccupationalProfile} from '../shared/occupational-profile';
import {IOccupationProfile} from '../shared/i-occupation-profile';
import {map} from 'rxjs/operators';

@Injectable()
export class OccupationalProfileService extends CoreService {
    private static BEROEPEN_PAGINA_API_UI_PATH = '/app-api/beroepenpagina/api/ui/occupationalprofiles';

    constructor(@Inject(HTTP_CLIENT_WITH_ERROR_HANDLING) private httpWithErrorHandling: HttpClient) {
        super();
    }

    public getOccupationProfileById(id: string): Observable<OccupationalProfile> {
        return this.httpWithErrorHandling.get<IOccupationProfile>(`${OccupationalProfileService.BEROEPEN_PAGINA_API_UI_PATH}/${id}`)
            .pipe(map(iOP => OccupationalProfile.fromInterface(iOP)));
    }
}
